import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "src/app/auth/services/auth.guard.service";
import { PerfilDpgeGuard } from "src/app/auth/guards/perfil.dpge.guard";
import { HomeDefaultComponent } from "../pages/home-default/home-default.component";
import { HomeInvestidorDpgeComponent } from "../pages/home-investidor-dpge/home-investidor-dpge.component";
import { HomeInvestidorComponent } from "../pages/home-investidor/home-investidor.component";
import { PerfilInvestidorComponent } from "../pages/perfil-investidor/perfil-investidor.component";
import { SolicitarGarantiaDpgeComponent } from "../pages/solicitar-garantia-dpge/solicitar-garantia-dpge.component";
import { SolicitarGarantiaComponent } from "../pages/solicitar-garantia/solicitar-garantia.component";

const routes: Routes = [
  {
    path: "spg",
    canActivate: [AuthGuardService],
    children: [
      { path: "", component: HomeDefaultComponent },
      { path: "home-ordinaria", component: HomeInvestidorComponent },
      { path: "home-dpge", component: HomeInvestidorDpgeComponent, canActivate: [PerfilDpgeGuard] },
      { path: "perfil-investidor", component: PerfilInvestidorComponent },
      {
        path: "consulta-solicitar-dpge",
        component: SolicitarGarantiaDpgeComponent,
      },
      {
        path: "solicita-garantia/:id/:nomeEmpresa/:cnpjEmpresa/:nome/:data/:exibirRepresentantes",
        component: SolicitarGarantiaComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class PortalRoutingModule {}
